import styled, {css} from "styled-components"
import Flex, {FlexProps} from "@irati/ui/src/Flex"
import {WorkSansBold} from "@irati/ui/src/global/fonts"
import {Label} from "@irati/ui/src/Typography"

interface StyledProps extends FlexProps {
  hasModal?: boolean
}

export const Wrapper = styled(Flex)<StyledProps>`
  ${({hasModal, theme}) => hasModal && theme.animations.hover}
  ${({theme}) => css`
    padding: ${theme.spacing.one};
    background-color: ${theme.colors.tertiary.o_50};
    border-radius: ${theme.spacing.one};
  `}
`

export const Image = styled.img`
  width: 14px;
  height: 14px;
`

export const HeroText = styled.p`
  ${({theme}) => css`
    font-family: ${theme.font.bold};
    font-size: 14px;
    color: ${theme.colors.greys.black};
    margin: 0;
    line-height: 1.2;
  `}
`

export const SecondaryText = styled.p`
  ${({theme}) => css`
    font-family: ${theme.font.bold};
    font-size: 10px;
    color: ${theme.colors.greys.black};
    margin: 0;
    line-height: 1.2;
  `}
`

export const StyledLabel = styled(Label)<{bold?: boolean}>`
  line-height: 1;
  ${({bold}) => css`
    ${bold && WorkSansBold};
  `}
`
